var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderBalanceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318986"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624116",
    x: 0.4,
    y: 5.60923,
    width: 19.2,
    height: 13.5659,
    rx: 3.6,
    stroke: "#EB8E2D",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624117",
    d: "M13.733 12.4916C13.733 11.1017 14.8598 9.97495 16.2497 9.97495H19.5997V15.0083H16.2497C14.8598 15.0083 13.733 13.8815 13.733 12.4916Z",
    stroke: "#EB8E2D",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 662",
    d: "M9.79395 5.57015L13.8356 3.45142",
    stroke: "#EB8E2D",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 986",
    cx: 16.2496,
    cy: 12.4918,
    r: 0.849593,
    stroke: "#EB8E2D",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66872 5.76816L11.8324 1.58321C13.9618 0.491602 16.4921 2.03794 16.4921 4.43084V5.76816H17.2921V4.43084C17.2921 1.43971 14.1292 -0.493208 11.4674 0.871298L1.91504 5.76816H3.66872ZM7.30198 19.5747L14.2921 19.5748C14.2992 19.5748 14.3064 19.5748 14.3135 19.5747H7.30198Z",
    fill: "#EB8E2D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBalanceIcon);
export default __webpack_public_path__ + "static/media/header-balance-icon.48228ce40f530b68f28b1b72881fee04.svg";
export { ForwardRef as ReactComponent };